document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('b2b-enquiry');
  if (!root) return;
  var tabs = root.querySelectorAll('.aob2b__tab');
  var select = root.querySelector('#B2BRequirement');
  var hidden = root.querySelector('#B2BRequestTypeHidden');
  var ingredient = root.querySelector('#B2BIngredient');
  var params = new URLSearchParams(window.location.search);

  function setRequest(type, updateUrl) {
    type = type === 'bulk' ? 'bulk' : 'sample';
    var value = type === 'bulk' ? 'Bulk Quote' : 'Sample';
    tabs.forEach(function(tab){
      var active = tab.dataset.request === type;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    if (select) select.value = value;
    if (hidden) hidden.value = value;
    if (updateUrl && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('request', type);
      url.hash = 'b2b-enquiry';
      history.replaceState({}, '', url);
    }
  }

  setRequest(params.get('request') || 'sample', false);
  if (ingredient && params.get('ingredient')) ingredient.value = params.get('ingredient');

  tabs.forEach(function(tab){tab.addEventListener('click', function(e){e.preventDefault();setRequest(tab.dataset.request, true);});});
  if (select) select.addEventListener('change', function(){setRequest(select.value === 'Bulk Quote' ? 'bulk' : 'sample', true);});
});
